'use strict';
var fails = require('../internals/fails');

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/string-html-forced.js
// module id = 625
// module chunks = 0